export enum GameTypeEnum {
	Prematch = 0,
	Live,
	FutureLive,
}

export const GameTypeViewEnum = {
	[GameTypeEnum.FutureLive]: "prematch",
	[GameTypeEnum.Live]: "live",
	[GameTypeEnum.Prematch]: "prematch",
};
